import Reflux from 'reflux';
import SpinnerActions from 'flux/actions/SpinnerActions';
import BaseMixin from 'flux/stores/BaseMixin';
import { Map } from 'immutable';
import EventShowListActions from 'flux/actions/EventShowListActions';
import EventCrewListActions from 'flux/actions/EventCrewListActions';
import TeamEventListActions from 'flux/actions/TeamEventListActions';
import UserEventListActions from 'flux/actions/UserEventListActions';

import {
  EventDash,
  EventCrew,
  TeamDashEventList,
  UserDash,
  UserDashEventList,
} from 'shared/constants/Spinners';

let onEventDashPopulateCompleted = EventShowListActions.populate.completed;
let onEventCrewPopulateCompleted = EventCrewListActions.populate.completed;

let onTeamEventListGetPagePopulateCompleted =
  TeamEventListActions.getPage.completed;
let onTeamEventListFilterChange = TeamEventListActions.notifyFilterChange;

let onUserDashPopulateCompleted = UserEventListActions.populate.completed;
let onUserEventListGetPagePopulateCompleted =
  UserEventListActions.getPage.completed;
let onUserEventListFilterChange = UserEventListActions.notifyFilterChange;

/**
 * SpinnerStore
 *
 * Keeps track of spinner visibility
 *
 */
export default Reflux.createStore({
  listenables: [SpinnerActions],

  mixins: [BaseMixin],

  init() {
    this.setState(Map());

    this.listenTo(onEventDashPopulateCompleted, () => this.onHide(EventDash));
    this.listenTo(onEventCrewPopulateCompleted, () => this.onHide(EventCrew));

    this.listenTo(onTeamEventListGetPagePopulateCompleted, () =>
      this.onHide(TeamDashEventList),
    );
    this.listenTo(onTeamEventListFilterChange, () =>
      this.onShow(TeamDashEventList),
    );

    this.listenTo(onUserDashPopulateCompleted, () => this.onHide(UserDash));
    this.listenTo(onUserEventListGetPagePopulateCompleted, () =>
      this.onHide(UserDashEventList),
    );
    this.listenTo(onUserEventListFilterChange, () =>
      this.onShow(UserDashEventList),
    );
  },

  onHide(key) {
    this.setInStateAndTrigger(key, false);
  },

  onShow(key) {
    this.setInStateAndTrigger(key, true);
  },
});
